/* eslint-disable */
import Vue from 'vue'
import User from '@/domain/User.js'
import VueLocalStorage from 'vue-ls'
import util from '@/util/Utils2.js'
import decode from 'jwt-decode'

Vue.use(VueLocalStorage)

export default class Auth {

  constructor(router) {
    this._initialized = false
    this._authenticated = false
    this._user = null
    this._next = null
    this._to = null
    this._router = router

    this.createAddAuthorizationInterceptor()
  }

  get initialized() {
    return this._initialized
  }

  get authenticated() {
    return this._authenticated
  }

  get user() {
    return this._user
  }

  saveForward(next, to) {
    this._next = next;
    this._to = to;
  }

  killForward() {
    this._next = null;
    this._to = null;
  }

  forward() {
    if (this._next !== null) {
      if (this._to.name == "home" || this._to.name == "login") {
        this._next({
          path: '/'
        })
      } else {
        this._next({
          path: this._router.path
        })
      }
      this.killForward();
    } else {
      this._next({
        path: '/'
      })
    }
  }

  openLogin() {
    this._router.push({
      path: 'login'
    })
  }

  check() {
    let token = Vue.ls.get('token')
    if (token) {
      this.readUserFromToken(token)
      if (!this._initialized) {
        this._initialized = true
        this.forward()
      }
    } else {
      if (!this._initialized) {
        this._initialized = true
        this.forward()
      }
      this.signout('', 'error')
    }
  }

  createAddAuthorizationInterceptor() {
    Vue.http.interceptors.push((request, next) => {
      if (this._authenticated) {
        let token = Vue.ls.get('token')
        if (token) {
          request.headers.set('Authorization', `Bearer ${token}`)
        }
      }
      next()
    })
  }

  proccessTokens(token) {
    this.limparAuth();
    this.readUserFromToken(token)

    let tokenDecoded = decode(token)
    Vue.ls.set('token', token, this.getTokenDuration(tokenDecoded))
  }

  readUserFromToken(token) {
    let tokenDecoded = decode(token)
    if (tokenDecoded.sub) {
      this._authenticated = true
      this._user = new User(tokenDecoded.sub)
    } else {
      this._authenticated = false
      this._user = null
    }
  }

  //retorna duration em milisegundos
  getTokenDuration(token) {
    return 86400000
    //return (token.exp - token.iat) * 1000
  }

  signin(username, password) {
    let login = username.toLowerCase()
    let data = 'email=' + login + '&password=' + password
    Vue.http.post(
      process.env.API + 'login', data, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }
    ).then(response => {
      if (response.ok && response.status === 200) {
        this.proccessTokens(response.data.token)
        util.showMessage('Logged in', 'success')
        this._router.push({
          name: 'home'
        })
      } else {
        util.showMessage('Error on login', 'error')
      }
    }).catch(() => {
      util.showMessage('Error on login', 'error')
    })
  }

  signout(msg = '', type = '') {
    this.limparAuth();
    if (msg != '') {
      util.showMessage(msg, type)
    }
    this.openLogin()
  }

  limparAuth() {
    Vue.ls.clear()
    this._authenticated = false
    this._user = null
  }
}



// WEBPACK FOOTER //
// ./src/auth2.js